import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import { ICommonServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import URLS from "@api/constants/urls";

export const useGetAllClaimTemplateService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters = {},
}: ICommonServiceProps) => {
  const [searchTemplate, setSearchTemplate] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchTemplate);

  const allClaimTemplate = useQuery({
    queryKey: [
      ...CACHE_KEYS.CLAIM_TEMPLATES,
      page,
      per_page,
      debouncedQuery,
      JSON.stringify(filters),
      ...cacheKeys,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CLAIM_TEMPLATES,
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
          include: "claimTypeFields.claimField.inputType,partner,plan",
          ...filters,
        },
      }),
    enabled: enableQuery,
  });
  return {
    service: { allClaimTemplate },
    state: { searchTemplate, setSearchTemplate },
  };
};

export const useGetSingleClaimTemplateService = () => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const claimTemplateId = +urlQueries["claim-template-id"] || "";
  const claimTypeId = urlQueries?.["claim-type-id"] || "";

  const singleClaimTemplateService = useQuery({
    queryKey: [...CACHE_KEYS.CLAIM_TEMPLATES, claimTemplateId],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: `${URLS.CLAIM_TEMPLATES}/${claimTemplateId}`,
        searchParams: {
          "filter[claim_type_id]": claimTypeId,
        },
      }),
    enabled: !!claimTemplateId,
  });

  return {
    service: { singleClaimTemplateService },
  };
};
